const PREFIX = "reservationPayment/";
export const CLEAR_CARD_INFO = `${PREFIX}CLEAR_CARD_INFO`;
export const SET_CARD_NUMBER = `${PREFIX}SET_CARD_NUMBER`;
export const SET_CVC = `${PREFIX}SET_CVC`;
export const SET_EXPIRATION_DATE = `${PREFIX}SET_EXPIRATION_DATE`;
export const SET_HOLDER_NAME = `${PREFIX}SET_HOLDER_NAME`;
export const SET_CPF = `${PREFIX}SET_CPF`;
